import { useState } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import HeaderContainer from "../../common/HeaderContainer";
import { SvgIcon } from "../../common/SvgIcon";
import { PngIcon } from "../../common/PngIcon";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
  MenuItemBg,
  LanguageText,
  SpanNoHover,
} from "./styles";

import { 
  LanguageSwitch, 
} from "../../styles/styles";

interface MenuItemProps {
  setVisible?: React.Dispatch<React.SetStateAction<boolean>>;
  t: TFunction;
  i18n: any;
}

const MenuItem = ({ setVisible, t, i18n }: MenuItemProps) => {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id) as HTMLDivElement | null;
    element?.scrollIntoView({
      behavior: "smooth",
    });
    setVisible?.(false);
  };

  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };
    
    return (
      <MenuItemBg style={{ display: "flex", alignItems: "center", gap: "2rem" }}>   
        <div style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}>
          <CustomNavLinkSmall onClick={() => scrollTo("about")}>
            <Span>{t("About")}</Span>
          </CustomNavLinkSmall>
          <CustomNavLinkSmall onClick={() => scrollTo("mission")}>
            <Span>{t("Mission")}</Span>
          </CustomNavLinkSmall>
          <CustomNavLinkSmall onClick={() => scrollTo("download")}>
            <Span>{t("Download")}</Span>
          </CustomNavLinkSmall>
          <CustomNavLinkSmall style={{ width: "180px" }} onClick={() => {globalThis.location.href = "mailto:nearalize@gmail.com"}}>
              <Button>{t("Contact")}</Button>
          </CustomNavLinkSmall>
          <LanguageText style={{ width: "180px" }}>
              <div style={{ display: "inline-flex"}}>
                <SpanNoHover>
                  {t("Language")}
                </SpanNoHover>
                <LanguageSwitch onClick={() => handleChange("en")}>
                  <SvgIcon
                    src="united-states.svg"
                    aria-label="English"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
                <LanguageSwitch onClick={() => handleChange("es")}>
                  <SvgIcon
                    src="spain.svg"
                    aria-label="Español"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
              </div>
          </LanguageText>
        </div>
      </MenuItemBg>
    );    
};


const Header = ({ t, i18n }: { t: TFunction; i18n: any }) => {
  const [visible, setVisible] = useState(false);

  const toggleButton = () => {
    setVisible(!visible);
  };

  return (
    <HeaderSection>
      <HeaderContainer>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <PngIcon src="whitelogo.png" height="64px" width="166px" />
          </LogoContainer>
          <NotHidden>
            <MenuItem setVisible={setVisible} t={t} i18n={i18n} />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItem setVisible={setVisible} t={t} i18n={i18n} />
        </Drawer>
      </HeaderContainer>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
